import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-500 font-medium"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id", "data-cy", "onClick"]
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-px my-2 bg-gray-300" }, null, -1)
const _hoisted_9 = ["id", "value", "placeholder", "disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_InputTextHelper = _resolveComponent("InputTextHelper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label && _ctx.label.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", {
            for: _ctx.id,
            class: "flex text-base font-medium leading-tight"
          }, _toDisplayString(_ctx.label), 9, _hoisted_3),
          (_ctx.isOptional)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('platform.common.optional')), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{
        'border-danger-700 hover:border-danger-700 focus:border-danger-700 focus:outline-none':
          _ctx.error|| !_ctx.isValid,
        'bg-gray-50 border-transparent': _ctx.readonly,
        'border-primary-500': _ctx.focused
      }, "flex flex-row h-12 bg-white border border-solid rounded text-medium w-full shadow hover:border-gray-500 transition-all duration-100 ease-in-out focus:shadow-md"]),
      "data-cy": "phone-number-outline"
    }, [
      _createElementVNode("div", {
        class: "relative",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", {
          "data-cy": "country",
          class: "inline-flex items-center w-32 h-12 cursor-pointer select-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
        }, [
          (_ctx.countryCode)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {"transform":"scale(0.5)"},
                class: _normalizeClass('-ml-3 flag flag-' + _ctx.countryCode.toLowerCase())
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.selectedCountry)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedCountry.dialCode), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_BaseIcon, {
            name: "chevron-down",
            position: "right"
          })
        ]),
        (!_ctx.readonly)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              ref: "countriesList",
              "data-cy": "country-list",
              class: _normalizeClass([_ctx.countriesOpened ? 'visible z-50' : 'invisible', "absolute h-40 overflow-y-scroll bg-white cursor-pointer shadow-lg border border-solid border-gray-300 rounded"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.countries), (countryKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  ref_for: true,
                  ref: `countries-${countryKey}`,
                  key: countryKey
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries[countryKey], (country) => {
                    return (_openBlock(), _createElementBlock("li", {
                      id: country.code,
                      key: country.code,
                      "data-cy": `country-${country.code}`,
                      class: _normalizeClass(["flex flex-row items-center h-8", 
                country.code === _ctx.countryCode ? 'bg-primary-500 text-white hover:bg-primary-700' : 'hover:bg-gray-100'
              ]),
                      onClick: ($event: any) => (_ctx.updateCountry(country.code))
                    }, [
                      _createElementVNode("span", {
                        style: {"transform":"scale(0.4)"},
                        class: _normalizeClass('flag flag-' + country.code.toLowerCase())
                      }, null, 2),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(country.name), 1)
                    ], 10, _hoisted_6))
                  }), 128))
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _hoisted_8,
      _createElementVNode("input", {
        id: _ctx.id,
        class: _normalizeClass([[_ctx.isValid && !_ctx.error ? 'border-gray-300' : 'border-danger-700', _ctx.readonly ? 'bg-gray-50' : ''], "px-3 w-full min-w-0 h-full border-none focus:outline-none"]),
        type: "tel",
        "data-cy": "phone-number-input",
        value: _ctx.formattedNumber,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focused = true)),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.focused = false)),
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateValue($event.target.value)))
      }, null, 42, _hoisted_9)
    ], 2),
    _createVNode(_component_InputTextHelper, {
      "data-cy": "input-error",
      error: _ctx.error || !_ctx.isValid ? _ctx.error || _ctx.$t('platform.error.phone-error') : '',
      description: _ctx.description
    }, null, 8, ["error", "description"])
  ]))
}